<template>
  <section class="p-4 bg-key rounded-4xl">
    <div>
      <h3 class="text-l-medium text-black-white">
        {{ $t('performance.keyboard.tickRate.title') }}
      </h3>
      <p class="mt-1 text-s-medium text-text-glass-default">
        {{ $t('performance.keyboard.tickRate.description') }}
      </p>
    </div>

    <RadioGroup
      v-model="model"
      :aria-label="$t('performance.keyboard.tickRate.title')"
      class="mt-3 flex flex-wrap gap-4"
    >
      <label v-for="option in options" :key="option.value">
        <div
          :class="
            model === option.value ? 'bg-white text-brand-blue1' : 'text-black-white hover:bg-key'
          "
          class="flex items-center gap-1.5 p-3 text-m-medium transition-colors cursor-pointer rounded-t-l rounded-b-l"
        >
          <RadioGroupItem :value="option.value" type="circle" />
          <span>{{ option.label }}</span>
        </div>
      </label>
    </RadioGroup>
  </section>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { RadioGroup, RadioGroupItem } from '@rapoo/element'
  import type { KeyboardPerformanceOption } from '../types'

  const model = defineModel<string>({ required: true })
  const { t } = useI18n()

  const options = computed<KeyboardPerformanceOption[]>(() => [
    { label: t('performance.keyboard.tickRate.none'), value: '0' },
    { label: t('performance.keyboard.tickRate.tick30'), value: '1' },
    { label: t('performance.keyboard.tickRate.tick60'), value: '2' },
  ])
</script>
